'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'tree';
var width = 512;
var height = 512;
var aliases = [127794];
var unicode = 'f1bb';
var svgPathData = ['M57.6 432l397.4 0-118-138.8-11.2-13.2 97.2 0-104.4-122.8-11.2-13.2 83.4 0-134.5-155.8-134.5 155.8 83.4 0-11.2 13.2-104.4 122.8 97.2 0-11.2 13.2-118 138.8z', 'M262.4-29.2l152 176 11.4 13.2-83.8 0 104.4 122.8 11.2 13.2-97.2 0 118 138.8 11.2 13.2-225.3 0 0 96-16 0 0-96-225.3 0 11.2-13.2 118-138.8-97.2 0 11.2-13.2 104.4-122.8-83.8 0 11.4-13.2 152-176 6.1-7 6.1 7zM121.8 144l83.4 0-11.2 13.2-104.4 122.8 97.2 0-11.2 13.2-118 138.8 397.4 0-118-138.8-11.2-13.2 97.2 0-104.4-122.8-11.2-13.2 83.4 0-134.5-155.8-134.5 155.8z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTree = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;